import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { Row, Col } from 'antd';

import { PaperClipOutlined } from '@ant-design/icons';

// Firebase
import firebase from "firebase/compat/app";

export default function ({ setLoader }) {
  const { id, token } = useParams();

  const [status, setStatus] = useState(null);
  const refuseMessage = firebase.app().functions('europe-west1').httpsCallable('refuseMessage');

  useEffect(() => {
    refuseMessage({ recipientId: id, token })
      .then((response) => {
        setLoader(false);
        setStatus(response.data);
      });
  }, []);

  return (
    <div style={{ display: 'flex', height: '100%', alignItems: 'center' }}>
      {
        // eslint-disable-next-line no-nested-ternary
        status
        && (status === 'accepted' || status === 'refused')
          ? (
            status === 'accepted'
              ? (<h2>Ce recommandé à déjà été accepté</h2>)
              : (<h2>Votre recommandé à bien été refusé</h2>)
          )
          : ''
      }
    </div>
  );
}
